import React from "react";

type IconProps = {
  name: string;
  className?: string;
  onClick?: any;
  width?: string;
  height?: string;
};

const Icon: React.FC<IconProps> = ({
  name,
  className,
  onClick,
  ...rest
}): React.ReactElement => {
  // console.log("${name}Icon", `${name}Icon`);
  const IconSvg = require(`../icons/${name}Icon`).default;
  // console.log('IconSvg', Ico nSvg);
  return (
    <div
      className={`flex p-1 m-2 items-center ${className ? className : ""}`}
      onClick={onClick}
    >
      {/* <img
        src={require(`../static/icons/${name}-icon.svg`)}
        alt={`${name} icon`}
        {...rest}
      /> */}
      <IconSvg />
    </div>
  );
};

export default Icon;
